<template>
  <div class="circle-loader-wrap">
    <section class="pane">
      <div style="position: absolute; top: 0px; left: 0px; display: table; width: 100%; height: 100%; z-index: 10;">
        <div style="display: table-cell; text-align: center; vertical-align: middle;"><img src="../assets/img/spinner.gif" class="loader-ie">
          <div class="loader">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" stroke-width="4" roke-miterlimit="10" class="path"></circle>
            </svg>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
  export default {
    name: 'loader'
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .circle-loader-wrap{
    position: fixed;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 99;
  }

  .loader {
    position: relative;
    margin: 0px auto;
    width: 50px;
  }

  .loader .circular {
    animation: rotate 2s linear infinite;
    height: 100%;
    transform-origin: center center;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }

  .loader:before {
    content: '';
    display: block;
    padding-top: 100%;
  }

  .loader .path {
    stroke-dasharray: 1,200;
    stroke-dashoffset: 0;
    animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
    stroke-linecap: round;
  }

  svg:not(:root) {
    overflow: hidden;
  }

  .loader-ie {
    display: none;
  }

  /* greater than equal IE 10 */
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .loader-ie {
      display: inline-block;
    }
  }

  @keyframes rotate{
    100%{
      transform: rotate(360deg);
    }
  }

  @keyframes dash{
    0%{
      stroke-dasharray: 1,200;
      stroke-dashoffset: 0;
    }
    50%{
      stroke-dasharray: 89,200;
      stroke-dashoffset: -35px;
    }
    100%{
      stroke-dasharray: 89,200;
      stroke-dashoffset: -124px;
    }
  }
  @keyframes color{
    100%, 0%{
      stroke: $primary-color-v2;
    }
  }
</style>



// WEBPACK FOOTER //
// ../common/components/Loader.vue